<div class="astrea-box astrea-doctrine-details h-100">
    <div class="d-flex j-c-between a-i-start flex-column h-100">
        <div class="d-flex j-c-start a-i-start flex-column">
            <h2>{{ doctrine.title }}</h2>
            <div class="d-flex j-c-start a-i-start">
                <div *ngFor="let a of authors; let i = index" style="margin-right: 5px;">
                    <span>{{ i > 0 ? ' - ' : '' }}</span>
                    <a  [routerLink]="['/author', a.authorcode]" class="doctrine-author" title="{{ 'books.details.author' | translate }}: {{ a.lastname }} {{ a.firstname }}">
                        {{ a.lastname | uppercase }}, {{ a.firstname }}
                    </a>
                </div>
            </div>
            <small>{{ 'books.details.year' | translate }}: {{ doctrine.year }} | {{ 'books.details.pages' | translate }}: {{ doctrine.pages }}</small>
        </div>
        <a (click)="getFile('book', doctrine.bookcode)" class="btn btn-doctrine" [attr.alt]="('see_doctrine' | translate) + ': ' + doctrine.title" mat-button>
            <div class="d-flex j-c-start a-i-center">
                {{ 'see_article' | translate }}
                <astrea-loading *ngIf="loadingFile" class="ml-2" [diameter]="20" [stroke]="2"></astrea-loading>
                <mat-icon *ngIf="!loadingFile">cloud_download</mat-icon>
            </div>
        </a>
    </div>
</div>
